export default __webpack_public_path__ + "static/media/spaceExplorerAnimation.7ab58930.gif";